import axios from "axios";

// DEMO
//const BASE_URL = 'https://demo.produceerp.com/';
// SANDBOX
// const BASE_URL = "https://sandbox.produceerp.com/";
// const BASE_URL = "http://192.168.189.250:8069";
// const BASE_URL = "http://sandbox.produceerp.com/dashboard/default";
// const BASE_URL =
//   "http://sandbox.produceerp.com/reservaerp/restful/usda/commodities";
// PROD
//const BASE_URL = 'http://react.produceerp.com/';

//SNADBOX LOCAL
const BASE_URL = "https://sandbox.produceerp.com/";

const HEADERS = {
  common: {
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Credentials": "true",
    // "Access-Control-Allow-Methods": "*",
    // "Access-Control-Allow-Headers": "Content-Type,Cookie,Set-Cookie",
    // "Content-Type": "application/json",
    // "Access-Control-Allow-Headers": "Content-Type, Authorization",
    //Auth local
    //'Authorization': '517a8f5c536fc863424b170d44fd8142589822a772c2c94cdc2946ac9586',
    //Auth demo
    //'Authorization': 'd0741961860a66757b1c27d15c77c7016dc897fc3334b7be70d2020685b2',
    //Auth sandbox
    // Authorization:
    //   "37e47b598b5be9a533b80efdca6c9a475cbb23701380025ae08b45981b14",
    // "ngrok-skip-browser-warning": "True",
  },
};

export const makeRequestBackend = async (method, endpoint, data) => {
  try {
    const response = await axios.request({
      method,
      baseURL: `https://leads-h8f5.onrender.com/${endpoint}`,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// export const makeRequestCom = async (method, endpoint, data) => {
//   try {
//     const response = await axios.request({
//       method,
//       baseURL: BASE_URL,
//       url: endpoint,
//       headers: HEADERS,
//       data,
//     });

//     return response;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

const makeRequest = async (method, endpoint, data) => {
  try {
    const response = await axios.request({
      method,
      baseURL: BASE_URL,
      url: endpoint,
      // headers: HEADERS,
      data,
    });
    // baseURL: "https://leads-h8f5.onrender.com",

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default makeRequest;

// const response = await axios.get({
//   baseURL: BASE_URL,
//   url: endpoint,
// });
// console.log(response);

// const response = await axios.get({
//   baseURL: BASE_URL,
//   url: "/reservaerp/restful/leads",
// });

// const response = await axios.get(
//   "http://sandbox.produceerp.com/reservaerp/restful/leads"
// );

// const response = await axios.get({
//   baseURL: BASE_URL,
//   url: "/reservaerp/restful/leads",
// });

// const response = await axios.get(
//   "http://sandbox.produceerp.com/reservaerp/restful/leads"
// );

// const response = await axios.get({
//   baseURL: BASE_URL,
//   url: endpoint,
// });
// console.log(response);
